import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../Common/AdminBreadcrumb';
import Loader from '../Common/Loader';

import { GetTournamentList, CreateGallery, DetailGallery } from '../../../API/admin'
import { GetTeams } from '../../../API/auth'

import { useSnackbar } from 'notistack';
import { useNavigate } from "react-router-dom"
import {
    CCard,
    CCardBody,
    CFormCheck,
} from '@coreui/react'
import Swal from 'sweetalert2';

const Gallery = () => {
    // Manage AdminBreadcrumb
    const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'Gallery', to: '/gallery', active: false },
        { label: 'Edit', to: '/tournament/create', active: true }
    ];
    let [loaderStatus, setloaderStatus] = useState(true)
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [tournamentList, setTournamentList] = useState([]);
    const [teams, setTeams] = useState([]);
    const [formState, setformState] = useState({
        tournament: '',
        team: '',
        game_type: '',
        images: [],
        tag: '',
        id: ''

    })
    const [imagePreviews, setImagePreviews] = useState([]);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        const previews = files.map(file => URL.createObjectURL(file));

        setformState(prevState => ({
            ...prevState,
            images: files
        }));

        setImagePreviews(previews);
    };

    useEffect(() => {

        let tournamentListApi = async () => {
            let res = await GetTournamentList()
            if (res.status) {
                setloaderStatus(false)
                setTournamentList(res.data);
                setformState(prevState => ({
                    ...prevState,
                    tournament: res.data[0]._id
                }));

            } else {
                setloaderStatus(false)
                enqueueSnackbar('Tournament not found', {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                })

            }
        }
        let getTeamsAPI = async () => {
            let res = await GetTeams();
            setTeams(res.data)
            console.log(res.data)
        }
        //     callAPI();
        tournamentListApi();
        getTeamsAPI()

    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        var urlid = {
            data: urlParams.get('id')
        }
        let callAPI = async () => {
            let res = await DetailGallery(urlid);
            if (res.status) {
                console.log(res.data.tournament_id.name)
                setformState(
                    {
                        tournament: res.data.tournament_id._id,
                        team: res.data.team_id._id,
                        game_type: res.data.game_type,
                        images: res.data.images,
                        tag: res.data.tag ? res.data.tag : '',
                        id: res.data.id ? res.data.id : null
                    }
                );
                // preview image  coming from backend while  update
                const previews = res.data.images.map(image => ` ${IMAGE_URL}/gallery/${image}`);

                setImagePreviews(previews)
            }
        }
        if (urlid) {
            callAPI();
        }
    }, [])
    const navigate = useNavigate();



    const handleChange = (e) => {
        const { name, value } = e.target;
        setformState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // const handleFileChange = (e) => {
    //     const files = Array.from(e.target.files);
    //     setformState(prevState => ({
    //         ...prevState,
    //         images: files
    //     }));
    // };



    const HandelSubmit = async (event) => {
        event.preventDefault()
        console.log(formState)
        const formData = new FormData();
        formData.append('tournament', formState.tournament);
        formData.append('team', formState.team);
        formData.append('game_type', formState.game_type);
        formData.append('tag', formState.tag);
        if (formState.id) {
            formData.append('id', formState.id)
        }

        let validSubmit = false;
        // Append each image file
        Array.from(formState.images).forEach((file) => {
            formData.append('images', file);
            const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

            // Generate image previews


            if (!validImageTypes.includes(file.type)) {
                Swal.fire({
                    title: 'Image format not supoorted',
                    text: 'You can only upload image of following format. webp, jpg, png, jpeg',
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })
                event.target.value = ''; // Clear the file input
                return;
            } else {
                validSubmit = true;

            }
        });
        if (validSubmit) {

            console.log(formData)
            let res = await CreateGallery(formData)
            if (res.data.status) {
                enqueueSnackbar('Data saved successfully', {
                    variant: 'success', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                });
                navigate('/gallery');
            } else {
                enqueueSnackbar(res.data.data.message, {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                });
            }
            imagePreviews.forEach(url => URL.revokeObjectURL(url));
        }

    }

    return (
        <>
            {loaderStatus ? <Loader /> : null}

            <h4 className="card-title mb-3 align-items-center">
                Add photos
            </h4>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />

            <CCard className="mb-4">
                <CCardBody>
                    <div className="row justify-content-center">
                        <div className="col-md-7">
                            <form onSubmit={HandelSubmit} enctype="multipart/form-data">
                                <div className="mb-3">
                                    <label className="form-label">Tournament</label>
                                    <select
                                        className='form-select'
                                        name='tournament'
                                        value={formState.tournament}
                                        onChange={handleChange}  // Attach handleChange here
                                        required
                                    >
                                        <option disabled value="">--: Select a Tournament :--</option>
                                        {tournamentList.length
                                            ? tournamentList.map((tournament, index) => (
                                                <option key={index} value={tournament._id.toString()}>
                                                    {tournament.name}
                                                </option>
                                            ))
                                            : ''}
                                    </select>
                                </div>
                                <div className='row mb-2'>
                                    <div className="col-6">
                                        <label htmlFor="exampleInputEmail1" className="form-label">Teams</label>
                                        <select
                                            name='team'
                                            className='mb-4 form-select'
                                            value={formState.team}
                                            onChange={handleChange}  // Attach handleChange here
                                            required

                                        >
                                            <option value="" disabled selected>Select a Team</option>
                                            {teams.length > 0 ? (
                                                teams.map((entry, index) => (
                                                    <option key={index} value={entry.id.toString()}>
                                                        {entry.domain}
                                                    </option>
                                                ))
                                            ) : null}
                                        </select>
                                    </div>
                                    <div className="col-6">
                                        <label htmlFor="exampleInputEmail1" className="form-label">Game</label>

                                        <select
                                            className='form-select'
                                            name='game_type'
                                            value={formState.game_type}
                                            onChange={handleChange}  // Attach handleChange here
                                            required

                                        >
                                            <option>--: Select a Game :--</option>
                                            <option value="badminton">Badminton</option>
                                            <option value="table_tenis">Table Tenis</option>
                                            <option value="bowling">Bowling</option>
                                            <option value="2k_run">2k run</option>
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Upload Images</label>
                                        <input
                                            type="file"
                                            name="images"
                                            accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
                                            className="form-control"
                                            multiple
                                            onChange={handleFileChange}
                                            required

                                        />
                                    </div>
                                    <div className="mb-3">

                                        {imagePreviews.length > 0 && (
                                            <>
                                                <label className="form-label">Preview</label>

                                                <div className="image-preview-container d-flex justify-content-center">
                                                    {imagePreviews.map((src, index) => (
                                                        <div key={index} className="  image-preview">
                                                            <img src={src} style={{ width: '100px', height: '100px' }} alt={`Preview ${index + 1}`} />
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Tag</label>
                                        <input
                                            type="text"
                                            name="tag"
                                            required
                                            value={formState.tag}
                                            className="form-control"
                                            onChange={handleChange}
                                            placeholder='enter a tag'
                                        />
                                    </div>
                                </div>
                                <button type="button" className="btn btn-secondary ms-3 float-end" onClick={() => window.history.back()}>
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary float-end">
                                    Save
                                </button>
                            </form>

                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </>
    )
}

export default Gallery